var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurso10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.61 127.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:gray;stroke-miterlimit:10;stroke-width:6.01px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_505",
    "data-name": "Trazado 505",
    className: "cls-1",
    d: "M121.59,9.85V100.3c0,11.64-15.83,12-25.39-.81-7.4-9.93-23.51-9.93-32.81-10H19.64A18.6,18.6,0,0,1,3.08,69.36v-22c0-11.62,7.76-21,17.32-21H63.09a48.34,48.34,0,0,0,33.1-15.53C106.31-.66,121.34,1.81,121.59,9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_506",
    "data-name": "Trazado 506",
    className: "cls-1",
    d: "M43.58,90.09v26a8.29,8.29,0,0,1-8.27,8.31H29.62a8.29,8.29,0,0,1-8.31-8.27v-26Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_97",
    "data-name": "L\\xEDnea 97",
    className: "cls-1",
    x1: 35.96,
    y1: 25.26,
    x2: 35.96,
    y2: 88.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_507",
    "data-name": "Trazado 507",
    className: "cls-1",
    d: "M121.6,77.29A27.79,27.79,0,0,0,123.31,38q-.82-.9-1.71-1.71"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso10);
export default __webpack_public_path__ + "static/media/Recurso 10.74040978489721890b2554c07be7cb36.svg";
export { ForwardRef as ReactComponent };